import { styled } from "@styles";

export const Button = styled.button`
  border: 1px solid gray;
  margin: .5rem .5rem 0 0;
  text-transform: none;
  color: gray;
  border-radius: 1rem;
  background-color: #fff;
  
  font-weight: 300;
  cursor: pointer;
  white-space: normal;
  line-height: 1.25;
  padding: .375rem .75rem;
  
  :hover {
    color: #FF3399;
    border-color: #FF3399;
  }
`;
